import type { TableRow } from "./types";

// Normaliza o valor do Tipo vindo de colagem/edição: aceita variações de caixa
export function normalizeType(value: any): "Host" | "POP" | "Mapa" {
  const v = String(value ?? "")
    .trim()
    .toLowerCase();
  if (v === "pop") return "POP";
  if (v === "mapa" || v === "map") return "Mapa";
  return "Host";
}

// Ícone padrão de acordo com o tipo do elemento.
export function defaultIconNameForType(
  type: "Host" | "POP" | "Mapa",
  icons: any[],
): string | null {
  if (type === "POP")
    return (
      icons?.find((i: any) => i.nome === "_pop" || i.nome === "pop")?.nome ??
      null
    );
  if (type === "Mapa")
    return (
      icons?.find((i: any) => i.nome === "_mapa" || i.nome === "mapa")?.nome ??
      null
    );
  return icons?.find((i: any) => i.nome === "_roteador")?.nome ?? null;
}

// Garante Tipo (vazio → Host) e Ícone (vazio → padrão do tipo) em uma linha.
export function fillRowDefaults(row: TableRow, icons: any[]) {
  if (!row.type) row.type = "Host";
  if (!row.iconId) {
    row.iconId = defaultIconNameForType(row.type, icons);
  }
  if (!Array.isArray(row.tags)) row.tags = [];
}
